module.exports = __webpack_public_path__ + "static/img/xwj1.4f84ec66.png";